<template>
  <div 
    id="app" 
    class="filter-app__container"
  >
    <Filters
      v-if="this.$store.state.filters.length > 0"
      :view="view"
      :remove="remove"
      :item-count="itemCount"
      @removed="removed"
      @noProductsFound="noProductsWereFound"
    />
    <div v-if="!ready">
      <div class="loader-container">
        <div class="loader">
          <div class="loader-inner ball-spin-fade-loader">
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
            <div />
          </div>
          <span>Loading&hellip;</span>
        </div>
      </div>
    </div>
    <FilterBreadcrumbs 
      :view="view"
      @remove="removeFilter"
    />
    <BrandsView
      v-if="view == 'brands' && ready"
      :category="view"
    />
    <EquipmentView
      v-if="view == 'equipment' && ready"
      :category="view"
    />
    <ProductsView
      v-if="view == 'products' || view === 'buyNow' && ready"
      :category="view"
      :no-products-found="noProductsFound"
      :page="productPage"
      @updateCount="updateCount"
    />
    <TrendsView
      v-if="view == 'trends' && ready"
      @updateCount="updateCount"
    />
    <RecipesView
      v-if="view == 'recipe' && ready"
      :page="productPage"
      @updateCount="updateCount"
    />
    <MerchandiseView
      v-if="view == 'merchandise' && ready"
      :page="productPage"
      @updateCount="updateCount"
    />
    <div
      v-if="errors.length > 0"
      class="error"
    >
      <ul>
        <li
          v-for="(error, index) in errors"
          :key="index"
        >
          {{ error }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
    const testMode = "products"

    import axios from "axios"

    import store from "./store"
    // import api from "./services/api.js"

    import Filters from "./components/Filters.vue"
    import BrandsView from "./components/BrandsView.vue"
    import EquipmentView from "./components/EquipmentView.vue"
    import ProductsView from "./components/ProductsView.vue"
    import TrendsView from "./components/TrendsView.vue"
    import RecipesView from "./components/RecipesView.vue"
    import MerchandiseView from "./components/MerchView.vue"
    import FilterBreadcrumbs from "./components/FilterBreadcrumbs.vue"

    export default {
        name: "App",
        components: {
            Filters,
            BrandsView,
            EquipmentView,
            ProductsView,
            TrendsView,
            RecipesView,
            MerchandiseView,
            FilterBreadcrumbs
        },
        data: () => {
            return {
                //items: [],
                errors: [],
                ready: false,
                //filters: [],
                //filterCategories: [],
                //selectedFilters: []
                remove: null,
                noProductsFound: false,
                productPage: null,
                itemCount: 0
            }
        },
        computed: {
            view: function() {
              return window.filteringMode ? window.filteringMode : testMode
            },
            productCategoryId: function() {
              return window.jms_product_filter_selected_category ? window.jms_product_filter_selected_category.id : 172
            },
            sectionTitle: function() {
              return window.listTitleOverride
            }
        },
        created() {
            if(this.view === 'products') {
                this.getProducts();
            } else if (this.view === 'buyNow') {
                this.getBuyNow();
            } else {
              this.getItems(this.view)
            }
            // if number of products query exists, then save and pass to view
          const decodedQuery = decodeURI((this.$route.query.page + ''));
          const queryValue = decodeURI(decodedQuery)
          if (queryValue !== 'undefined'){
            this.productPage = parseInt(queryValue)
          }

        },
        methods: {
          updateCount (incomingCount) {
            this.itemCount = incomingCount;
          },
          noProductsWereFound(e) {
            this.noProductsFound = e
          },
         removeFilter(e) {
            this.remove = e
          },
          removed(){
            this.remove = null
          },
            getItems: function(view) {
                axios.get(process.env.VUE_APP_APIHOST + "api/"+view+"/list")
                    .then(response => {
                        // JSON responses are automatically parsed.
                        // this.items = response.data.items
                        // this.filters = response.data.filters
                        // this.filterCategories = response.data.filterCategories
                        // console.log(this.items)
                        this.initializeStore(response.data)
                        //this.putFiltersInStore(response.data)
                        this.ready = true
                    })
                    .catch(e => {
                        this.errors.push(e)
                        console.error(e)
                        this.ready = false
                    })
                // try {
                //   console.log('api', api)
                //   this.items = api()
                //   this.ready = true
                // } catch (e) {
                //   this.errors.push(e)
                //   this.ready = false
                // }

                // async / await version (created() becomes async created())
                //
                // try {
                //   const response = await axios.get(`http://jsonplaceholder.typicode.com/posts`)
                //   this.posts = response.data
                // } catch (e) {
                //   this.errors.push(e)
                // }
            },
            getProducts: function() {
                axios.get(process.env.VUE_APP_APIHOST + "api/product/list/" + this.productCategoryId)
                    .then(response => {
                        //If this page has specified which filters to use.. let's remove the others
                        if(window.jms_product_filter_filters_available) {
                            let filters = response.data.filters;
                            let new_filters = [];

                            for(var i = 0; i < filters.length; i++) {
                                for(var j = 0; j < window.jms_product_filter_filters_available.length; j++) {
                                    if(filters[i].categoryName === window.jms_product_filter_filters_available[j].name) {
                                        for(var k = 0; k < response.data.items.length; k++) {
                                            if(response.data.items[k].tags.indexOf(filters[i].id) > -1) {
                                                new_filters.push(filters[i]);
                                                break;
                                            }

                                        }
                                    }
                                }
                            }

                            response.data.filters = new_filters;
                        }
                        this.initializeStore(response.data)
                        this.ready = true
                    })
                    .catch(e => {
                        this.errors.push(e)
                        console.error("ERROR", e)
                        this.ready = false
                    })
            },
          
            // Specifically for the Buy Now landing page
            getBuyNow: function() {
                axios.get(process.env.VUE_APP_APIHOST + "api/product/list/590")
                    .then(response => {
                      const remove = window.remove;
                      // console.log('remove: ', remove);
                      let filters = response.data.filters;
                      let new_filters = [];
                        for(var i = 0; i < filters.length; i++) {
                          if(!remove.includes(filters[i].categoryName)) {
                            new_filters.push(filters[i]);
                          } else {
                            // console.log('removing id: ', filters[i].id);
                            continue;
                          }
                        }
                        response.data.filters = new_filters;
                        this.initializeStore(response.data)
                        // console.log('filters response data: ', response.data.filters)
                        this.ready = true
                    })
                    .catch(e => {
                        this.errors.push(e)
                        console.error("ERROR", e)
                        this.ready = false
                    })
            },
            initializeStore: function(payload) {
                store.dispatch('initialize', payload).then(() => {
                  if(this.view === 'buyNow'){
                    store.dispatch('filterFilters')
                  }
                  store.dispatch('applySort');
                }).catch((error) => {
                    // Display error messages
                    console.error(error)
                });
            },
            putFiltersInStore: function(payload) {
                store.dispatch('setFilters', payload).then(() => {
                    // anything?
                }).catch((error) => {
                    // Display error messages
                    console.error(error)
                });
            }
            // getFilters: function(items) {
            //   if (items) {
            //     // items.forEach(i => {
            //     //   // console.log('item tags', i.tags)
            //     //   if (i.tags) {
            //     //     this.filters.push(i.tags)
            //     //     // store.state.commit('addfilters')
            //     //   }
            //     // })
            //     store.dispatch('initFilters', items)
            //   }
            // }
        }
    }
</script>

